import * as React from "react";
import TextFieldMUI from "@mui/material/TextField";

type Props = {
  type?: string;
  label: string;
  value?: string;
  setValue: (value: string) => void;
  hasValueError?: boolean;
  setHasValueError?: (state: boolean) => void;
  isRequired?: boolean;
  errorLabel?: string;
  shrinkOnAutoFill?: boolean;
};

export const TextField = (props: Props) => {
  const {
    type,
    value,
    setValue,
    hasValueError,
    setHasValueError,
    isRequired,
    label: labelName,
    errorLabel,
    shrinkOnAutoFill = false,
  } = props;

  const [isAutofilled, setIsAutofilled] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);

  const inputName = React.useCallback(
    (event: { target: { value: any } }) => {
      const inputValue = event.target.value;
      const isEmpty = inputValue === "";
      setValue(inputValue);
      setHasValueError && setHasValueError(isEmpty);
    },
    [setValue, setHasValueError]
  );

  React.useEffect(() => {
    if (!shrinkOnAutoFill) {
      return;
    }

    const checkAutofill = () => {
      if (inputRef.current) {
        const autofilled = inputRef.current.matches(":autofill");
        setIsAutofilled(autofilled);
      }
    };

    // 初回チェック
    checkAutofill();

    // 定期的にチェック（自動入力は非同期で発生する可能性があるため）
    const interval = setInterval(checkAutofill, 100);

    // アニメーション終了時にもチェック
    const input = inputRef.current;
    if (input) {
      input.addEventListener("animationstart", checkAutofill);
    }

    return () => {
      clearInterval(interval);
      if (input) {
        input.removeEventListener("animationstart", checkAutofill);
      }
    };
  }, [shrinkOnAutoFill]);

  return (
    <TextFieldMUI
      type={type ?? "text"}
      style={{ width: "100%" }}
      size="small"
      autoComplete="section-blue shipping street-address"
      label={labelName}
      required={isRequired ? true : false}
      value={value || ""}
      error={hasValueError}
      onChange={inputName}
      helperText={hasValueError ? errorLabel + "を入力してください。" : ""}
      inputRef={inputRef}
      InputLabelProps={{
        shrink: (shrinkOnAutoFill && isAutofilled) || value ? true : undefined,
      }}
    />
  );
};
